export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-24 border-t bg-white/70 backdrop-blur">
      <div className="border-t">
        <div className="max-w-6xl mx-auto px-4 py-4 text-sm text-slate-600 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>© {year} Axorclean. Toate drepturile rezervate.</span>
          <span className="text-slate-500">
            Curățenie profesională la tine acasă și în mașină.
          </span>
        </div>
      </div>
    </footer>
  );
}
